import CargoCompanyPassengerListRequest from "../../../../api/raily/cargo-company/passenger/list/cargo-company-passenger-list.request";
import CargoCompanyPassengerListParams from "./cargo-company-passenger-list-params";

const create = (
  params: CargoCompanyPassengerListParams,
): CargoCompanyPassengerListRequest => {
  return {
    companyUuid: params.companyUuid,
    searchQuery: params.searchQuery,
  };
};

const cargoCompanyPassengerListParamsFactory = {
  create,
};

export default cargoCompanyPassengerListParamsFactory;
